"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _arrays = require("@mulesoft/exchange-ui-portals-store/lib/utils/arrays");
var _assets = require("@mulesoft/exchange-ui-portals-store/lib/utils/assets");
var actions = _interopRequireWildcard(require("./actionTypes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initialState = {
  data: {
    external: {},
    versioned: {}
  },
  ui: {
    isCreatingInstance: false,
    isFetchingList: false,
    errors: [],
    instances: {}
  }
};
function splitInstances(instances) {
  var external = [];
  var versioned = [];
  instances.forEach(function (instance) {
    if (instance.type === 'external') {
      external.push(instance);
    } else {
      versioned.push(instance);
    }
  });
  return {
    external: external,
    versioned: versioned
  };
}
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var apiVersionPath = (0, _assets.getGAPKey)(action);
  var minorVersionPath = (0, _assets.getGAMKey)(action);
  function setInstanceUIData(instanceId, uiData) {
    return _objectSpread(_objectSpread({}, state.ui), {}, {
      instances: (0, _defineProperty2.default)({}, instanceId, uiData)
    });
  }
  function setInstanceData(instance, newInstances) {
    if (instance.type === 'external') {
      return _objectSpread(_objectSpread({}, state.data), {}, {
        external: _objectSpread(_objectSpread({}, state.data.external), {}, (0, _defineProperty2.default)({}, apiVersionPath, newInstances))
      });
    }
    return _objectSpread(_objectSpread({}, state.data), {}, {
      versioned: _objectSpread(_objectSpread({}, state.data.versioned), {}, (0, _defineProperty2.default)({}, minorVersionPath, newInstances))
    });
  }
  function getCurrentInstances(instanceType) {
    return (instanceType === 'external' ? state.data.external[apiVersionPath] : state.data.versioned[minorVersionPath]) || [];
  }
  switch (action.type) {
    case actions.FETCH_API_INSTANCE_LIST.REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, {
            external: _objectSpread(_objectSpread({}, state.data.external), {}, (0, _defineProperty2.default)({}, apiVersionPath, [])),
            versioned: _objectSpread(_objectSpread({}, state.data.versioned), {}, (0, _defineProperty2.default)({}, minorVersionPath, []))
          }),
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isFetchingList: true,
            errors: []
          })
        });
      }
    case actions.FETCH_API_INSTANCE_LIST.SUCCESS:
      {
        var _splitInstances = splitInstances(action.result),
          external = _splitInstances.external,
          versioned = _splitInstances.versioned;
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, {
            external: _objectSpread(_objectSpread({}, state.data.external), {}, (0, _defineProperty2.default)({}, apiVersionPath, !state.data.external[apiVersionPath] || state.data.external[apiVersionPath].length === 0 ? external : state.data.external[apiVersionPath])),
            versioned: _objectSpread(_objectSpread({}, state.data.versioned), {}, (0, _defineProperty2.default)({}, minorVersionPath, versioned))
          }),
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isFetchingList: false,
            errors: []
          })
        });
      }
    case actions.FETCH_API_INSTANCE_LIST.FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        ui: _objectSpread(_objectSpread({}, state.ui), {}, {
          isFetchingList: false,
          errors: [action.error]
        })
      });
    case actions.CREATE_EXTERNAL_API_INSTANCE.REQUEST:
      {
        var instances = state.data.external[apiVersionPath] || [];
        var index = instances.findIndex(function (_ref) {
          var isCreating = _ref.isCreating;
          return isCreating;
        });
        var instance = _objectSpread(_objectSpread({}, action.params.instance), {}, {
          isCreating: true
        });
        var newInstances = index >= 0 ? (0, _arrays.replaceInArray)(instances, instance, {
          index: index
        }) : [].concat((0, _toConsumableArray2.default)(instances), [instance]);
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, {
            external: _objectSpread(_objectSpread({}, state.data.external), {}, (0, _defineProperty2.default)({}, apiVersionPath, newInstances))
          }),
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isCreatingInstance: true
          })
        });
      }
    case actions.CREATE_EXTERNAL_API_INSTANCE.FAILURE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isCreatingInstance: false
          })
        });
      }
    case actions.CREATE_EXTERNAL_API_INSTANCE.SUCCESS:
      {
        var _instances2 = state.data.external[apiVersionPath] || [];
        var _instance = _objectSpread(_objectSpread(_objectSpread({}, action.params.instance), action.result), {}, {
          fullname: action.params.instance.name,
          isCreating: false
        });
        var _newInstances = (0, _arrays.replaceInArray)(_instances2, _instance, {
          findFn: function findFn(_ref2) {
            var isCreating = _ref2.isCreating;
            return isCreating;
          }
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, {
            external: _objectSpread(_objectSpread({}, state.data.external), {}, (0, _defineProperty2.default)({}, apiVersionPath, _newInstances))
          }),
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isCreatingInstance: false
          })
        });
      }
    case actions.UPDATE_API_INSTANCE.REQUEST:
      {
        var _instance2 = _objectSpread(_objectSpread({}, action.params.instance), {}, {
          fullname: action.params.instance.environmentName ? "".concat(action.params.instance.environmentName, " - ").concat(action.params.instance.name) : action.params.instance.name,
          isEditing: true
        });
        var _instances3 = getCurrentInstances(_instance2.type);
        var _index = _instances3.findIndex(function (_ref3) {
          var id = _ref3.id;
          return id === _instance2.id;
        });
        var _newInstances2 = (0, _arrays.replaceInArray)(_instances3, _instance2, {
          index: _index
        });
        var uiData = {
          index: _index,
          beforeUpdate: _instances3[_index],
          isLoading: true
        };
        return _objectSpread(_objectSpread({}, state), {}, {
          data: setInstanceData(_instance2, _newInstances2),
          ui: setInstanceUIData(_instance2.id, uiData)
        });
      }
    case actions.UPDATE_API_INSTANCE.FAILURE:
      {
        var _instance3 = _objectSpread(_objectSpread({}, action.params.instance), {}, {
          isEditing: false
        });
        var _instances4 = getCurrentInstances(_instance3.type);
        var instanceBeforeUpdate = state.ui.instances[_instance3.id].beforeUpdate;
        var _newInstances3 = (0, _arrays.replaceInArray)(_instances4, instanceBeforeUpdate, {
          findFn: function findFn(_ref4) {
            var id = _ref4.id;
            return id === _instance3.id;
          }
        });
        var _uiData = {
          isLoading: false
        };
        return _objectSpread(_objectSpread({}, state), {}, {
          data: setInstanceData(_instance3, _newInstances3),
          ui: setInstanceUIData(_instance3.id, _uiData)
        });
      }
    case actions.UPDATE_API_INSTANCE.SUCCESS:
      {
        var _instance4 = _objectSpread(_objectSpread({}, action.params.instance), {}, {
          fullname: action.params.instance.environmentName ? "".concat(action.params.instance.environmentName, " - ").concat(action.params.instance.name) : action.params.instance.name,
          isEditing: false
        });
        var _instances5 = getCurrentInstances(_instance4.type);
        var _newInstances4 = (0, _arrays.replaceInArray)(_instances5, _instance4, {
          findFn: function findFn(_ref5) {
            var id = _ref5.id;
            return id === _instance4.id;
          }
        });
        var _uiData2 = {
          isLoading: false
        };
        return _objectSpread(_objectSpread({}, state), {}, {
          data: setInstanceData(_instance4, _newInstances4),
          ui: setInstanceUIData(_instance4.id, _uiData2)
        });
      }
    case actions.DELETE_API_INSTANCE.REQUEST:
      {
        var _instance5 = action.params.instance;
        var _instances6 = getCurrentInstances(_instance5.type);
        var _index2 = _instances6.findIndex(function (_ref6) {
          var id = _ref6.id;
          return id === _instance5.id;
        });
        var _newInstances5 = (0, _arrays.removeFromArray)(_instances6, {
          index: _index2
        });
        var _uiData3 = {
          beforeDelete: _instances6[_index2],
          index: _index2,
          isLoading: true
        };
        return _objectSpread(_objectSpread({}, state), {}, {
          data: setInstanceData(_instance5, _newInstances5),
          ui: setInstanceUIData(_instance5.id, _uiData3)
        });
      }
    case actions.DELETE_API_INSTANCE.FAILURE:
      {
        var _instance6 = action.params.instance;
        var _instances7 = getCurrentInstances(_instance6.type);
        var _state$ui$instances$_ = state.ui.instances[_instance6.id],
          _index3 = _state$ui$instances$_.index,
          beforeDelete = _state$ui$instances$_.beforeDelete;
        var _newInstances6 = (0, _arrays.insertInArray)(_instances7, beforeDelete, {
          index: _index3
        });
        var _uiData4 = {
          isLoading: false
        };
        return _objectSpread(_objectSpread({}, state), {}, {
          data: setInstanceData(_instance6, _newInstances6),
          ui: setInstanceUIData(_instance6.id, _uiData4)
        });
      }
    case actions.DELETE_API_INSTANCE.SUCCESS:
      {
        var _uiData5 = {
          isLoading: false
        };
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: setInstanceUIData(action.params.instance.id, _uiData5)
        });
      }
    case actions.SET_API_INSTANCE_IS_LOADING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: setInstanceUIData(action.instanceId, {
            isLoading: action.isLoading
          })
        });
      }
    default:
      return state;
  }
}
//# sourceMappingURL=reducer.js.map